
export const KEY__MODEL__RESUME_HIGHLIGHTS = 'resumeHighlights';
export const KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST = 'nonComplexTasksList';

export default function getDefaultModelResumeHighlights() {
  return {
    [KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST]: [
      "Migration",
      "Migrated",
      "Testing",
      "Test",
      "Refactor",
      "Refactoring",
      "Tech debt",
      "Maintenance",
      "Maintained",
      "Porting",
      "Ported",
      "CI/CD",
      "Dashboards",
      "Internal tools",
      "Monitoring",
      "Prototyping",
      "Mentoring",
      "agile",
      "scrum",
    ]
  }
}
